import { ContainerSwitch } from './styles';
import { Switch, SwitchProps } from 'antd';

export const ASwitch: React.FC<SwitchProps> = ({ ...res }) => {
  return (
    <ContainerSwitch>
      <Switch {...res} />
    </ContainerSwitch>
  );
};
